webpackJsonp([281026976107462],{

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Bluestate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Bluestate() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "10 0 200 72", width: 200, height: 72 },
	    _react2.default.createElement("path", {
	      fill: "currentColor",
	      d: "M23.82,35.71a3.35,3.35,0,0,0,1.34-2.85,3.17,3.17,0,0,0-1.11-2.55,5.67,5.67,0,0,0-3.62-.91H14.91a.19.19,0,0,0-.19.19v13a.19.19,0,0,0,.19.19h5.41a6.71,6.71,0,0,0,3.84-1,3.42,3.42,0,0,0,1.44-3A3,3,0,0,0,23.82,35.71Zm-1.88-1.34a2.74,2.74,0,0,1-1.56.38h-3V31.9h2.78a3.41,3.41,0,0,1,1.85.36,1.25,1.25,0,0,1,.48,1.1A1.14,1.14,0,0,1,21.94,34.37Zm-4.59,2.81h3a3.87,3.87,0,0,1,2,.38,1.21,1.21,0,0,1,.55,1.12,1.3,1.3,0,0,1-.6,1.22,4.21,4.21,0,0,1-2.11.4H17.35Zm24,3.3V42.6a.18.18,0,0,1-.19.19H31.55a.19.19,0,0,1-.19-.19v-13a.19.19,0,0,1,.19-.19H33.8a.18.18,0,0,1,.19.19V40.3h7.19A.18.18,0,0,1,41.37,40.48ZM58,29.59v7.47a7.15,7.15,0,0,1-.47,2.67,4.64,4.64,0,0,1-1.3,1.85,6.19,6.19,0,0,1-1.78,1,6.29,6.29,0,0,1-2,.33,6,6,0,0,1-4.21-1.56A5.75,5.75,0,0,1,46.44,37V29.59a.19.19,0,0,1,.19-.19h2.25a.19.19,0,0,1,.19.19v7.08A4,4,0,0,0,50,39.42a3,3,0,0,0,2.37,1,2.59,2.59,0,0,0,2.21-1,4.45,4.45,0,0,0,.76-2.71V29.59a.18.18,0,0,1,.19-.19h2.25A.19.19,0,0,1,58,29.59ZM74.39,40.48V42.6a.18.18,0,0,1-.19.19H64.35a.19.19,0,0,1-.19-.19v-13a.19.19,0,0,1,.19-.19H74a.19.19,0,0,1,.19.19v2.12a.2.2,0,0,1-.19.19H66.79v2.89h6.75a.19.19,0,0,1,.18.19v2a.18.18,0,0,1-.18.19H66.79V40.3H74.2A.18.18,0,0,1,74.39,40.48Z"
	    }),
	    _react2.default.createElement("path", {
	      fill: "currentColor",
	      d: "M134.35,38.9a3.49,3.49,0,0,1-1.52,2.92,6,6,0,0,1-3.67,1.12,8.46,8.46,0,0,1-3.36-.69,6.51,6.51,0,0,1-2.51-1.76.18.18,0,0,1,0-.24l1.34-1.58a.17.17,0,0,1,.14-.07.22.22,0,0,1,.14.06,5.89,5.89,0,0,0,4.46,1.8,3.17,3.17,0,0,0,1.72-.39,1.11,1.11,0,0,0,.56-1,1.13,1.13,0,0,0-.38-.86,3,3,0,0,0-1.09-.61c-.46-.15-1-.29-1.54-.42s-1.16-.29-1.73-.47a8.94,8.94,0,0,1-1.6-.67,3.53,3.53,0,0,1-1.22-1.15,3.29,3.29,0,0,1-.47-1.77,3.33,3.33,0,0,1,1.52-2.76,6.1,6.1,0,0,1,3.76-1.11,6.93,6.93,0,0,1,5.18,1.92.18.18,0,0,1,0,.24L132.86,33a.16.16,0,0,1-.13.07.15.15,0,0,1-.14,0,5.71,5.71,0,0,0-3.74-1.31,4.28,4.28,0,0,0-1.86.36,1,1,0,0,0-.67,1,1,1,0,0,0,.51.86,4.39,4.39,0,0,0,1.42.57c.6.13,1.26.3,1.95.5s1.35.44,2,.68a3.65,3.65,0,0,1,1.57,1.21A3.28,3.28,0,0,1,134.35,38.9Zm15.47-9.5h-11a.19.19,0,0,0-.19.19v2.12a.2.2,0,0,0,.19.19H143V42.6a.19.19,0,0,0,.19.19h2.25a.19.19,0,0,0,.19-.19V31.9h4.18a.2.2,0,0,0,.19-.19V29.59A.19.19,0,0,0,149.82,29.4Zm15.59,13.31a.21.21,0,0,1-.16.08h-2.36a.18.18,0,0,1-.17-.11l-1.22-2.77h-5.68l-1.2,2.77a.18.18,0,0,1-.17.11h-2.33a.18.18,0,0,1-.15-.08.19.19,0,0,1,0-.18l5.71-13a.18.18,0,0,1,.17-.11h1.71a.19.19,0,0,1,.18.11l5.7,13A.19.19,0,0,1,165.41,42.71ZM160.5,37.6l-1.85-4.28L156.8,37.6Zm18.05-8.2h-11a.18.18,0,0,0-.19.19v2.12a.19.19,0,0,0,.19.19h4.18V42.6a.18.18,0,0,0,.19.19h2.25a.19.19,0,0,0,.19-.19V31.9h4.18a.19.19,0,0,0,.18-.19V29.59A.18.18,0,0,0,178.55,29.4Zm15.26,10.9h-7.42V37.21h6.75a.18.18,0,0,0,.19-.19V35a.19.19,0,0,0-.19-.19h-6.75V31.9h7.24a.19.19,0,0,0,.18-.19V29.59a.18.18,0,0,0-.18-.19H184a.18.18,0,0,0-.19.19v13a.18.18,0,0,0,.19.19h9.85a.18.18,0,0,0,.19-.19V40.48A.18.18,0,0,0,193.81,40.3Z"
	    }),
	    _react2.default.createElement("path", {
	      fill: "currentColor",
	      d: "M111.57,36.1l4.05-4.27a.67.67,0,0,0,0-.91L100.94,15.43a.67.67,0,0,0-.48-.21H82.63a.67.67,0,0,0-.48,1.12L90,24.67H82.63a.66.66,0,0,0-.6.4.64.64,0,0,0,.12.71L91.92,36.1,82.15,46.41a.66.66,0,0,0,.48,1.11H90l-7.89,8.33A.67.67,0,0,0,82.63,57h17.83a.67.67,0,0,0,.48-.21l14.68-15.49a.67.67,0,0,0,0-.91ZM98.82,41.27a.67.67,0,0,0,0-.91l-4-4.26,4-4.27a.67.67,0,0,0,0-.91l-3.95-4.18h5l8.86,9.36-8.86,9.35h-5Zm2.12-16.4a.66.66,0,0,0-.48-.2H92.9l-7-7.37H99.85l13.34,14.07-3,3.22Zm-4.55,6.5-3,3.22-7.43-7.85H92Zm0,9.45L92,45.45H85.92l7.43-7.85Zm4.07,6.7a.66.66,0,0,0,.48-.2l9.2-9.72,3,3.22L99.85,54.89H85.92l7-7.37Z"
	    })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Rapp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Rapp() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "50 25 200 50", width: "150", height: "25" },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", {
	        d: "M67.99,41.88c0-7.01-5.19-12.43-13.33-12.43H38.33v40.42h8.2V54.3h4.25l8.2,15.56h9.08l-8.96-16.53 C64.57,51.8,67.99,47.52,67.99,41.88z M53.13,47.52h-6.6V36.29h6.6c4.13,0,6.55,2.22,6.55,5.64 C59.68,45.24,57.26,47.52,53.13,47.52z"
	      }),
	      _react2.default.createElement("path", {
	        d: "M85.09,29.45L70.79,69.87h7.67l3.1-9.23H96.7l3.1,9.23h7.88L93.49,29.45H85.09z M83.98,53.45l5.15-15.28l5.15,15.28H83.98z "
	      }),
	      _react2.default.createElement("path", {
	        d: "M127.63,29.45h-15.63v40.42h8.14V54.65h7.49c8.26,0,13.74-5.24,13.74-12.6C141.37,34.75,135.88,29.45,127.63,29.45z M126.62,47.86h-6.43V36.29h6.43c4.07,0,6.55,2.22,6.55,5.81C133.17,45.58,130.69,47.86,126.62,47.86z"
	      }),
	      _react2.default.createElement("path", {
	        d: "M164.29,29.45h-15.63v40.42h8.14V54.65h7.49c8.26,0,13.74-5.24,13.74-12.6C178.03,34.75,172.55,29.45,164.29,29.45z M163.28,47.86h-6.43V36.29h6.43c4.07,0,6.55,2.22,6.55,5.81C169.83,45.58,167.35,47.86,163.28,47.86z"
	      }),
	      _react2.default.createElement("rect", { x: "187.83", y: "28.9", width: "42.15", height: "40.96" })
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Cta;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _generalModule = __webpack_require__(250);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cta(_ref) {
	  var heading = _ref.heading,
	      ctaLink = _ref.ctaLink;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.cta },
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'l', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'm', sizeM: '0', position: 'leftRight', type: 'padding' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 760 },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xxxl', weight: 'semibold', color: 'black' },
	              heading
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: ctaLink },
	        _react2.default.createElement(
	          _button2.default,
	          { shape: 'rounded', kind: 'flat', size: 'large' },
	          'Request a demo'
	        )
	      )
	    )
	  );
	}
	
	Cta.propTypes = {
	  heading: _customPropTypesCheck2.default,
	  ctaLink: _propTypes2.default.string
	};
	
	Cta.defaultProps = {
	  heading: 'Challenge the industry norm and become a CX centric design leader with Marvel Enterprise.',
	  ctaLink: '/enterprise/request-demo'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cta":"src-components-modules-Cta-CtaDemo-style----general-module---cta---35v6-"};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = IndustryHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _headerModule = __webpack_require__(253);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndustryHeader(_ref) {
	  var label = _ref.label,
	      imageAsset = _ref.imageAsset,
	      title = _ref.title,
	      paragraph = _ref.paragraph,
	      ctaLink = _ref.ctaLink;
	
	  var buttons = _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeM: 'l', position: 'top', type: 'margin' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.buttons },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.leftButton },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: ctaLink },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              size: 'large',
	              background: 'blue',
	              hover: 'blue',
	              shape: 'rounded',
	              minWidth: 180
	            },
	            'Request a demo'
	          )
	        )
	      )
	    )
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: _headerModule2.default.flex },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.firstCol },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', position: 'bottom', type: 'margin' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'm', weight: 'semibold' },
	            _react2.default.createElement(
	              'span',
	              { className: _headerModule2.default.label },
	              label
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: _headerModule2.default.heading },
	          title
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 500 },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 's', position: 'top', type: 'margin' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'm', color: 'black' },
	              paragraph
	            )
	          )
	        ),
	        buttons
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.secondCol },
	      _react2.default.createElement(_Image2.default, _extends({}, imageAsset, { hasShadow: false, block: true }))
	    )
	  );
	}
	
	IndustryHeader.propTypes = {
	  imageAsset: _propTypes2.default.object,
	  label: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  paragraph: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  ctaLink: _propTypes2.default.string.isRequired
	};
	
	IndustryHeader.defaultProps = {
	  ctaLink: '/enterprise/request-demo'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-IndustryHeader-style----header-module---flex---2XcZw pageWrap pageWrap-l alignItems-center justifyContent-center breakPointM-display-flex breakPointM-textAlign-left","firstCol":"src-components-modules-IndustryHeader-style----header-module---firstCol---284-C breakPointM-marginBottom-0 breakPointM-marginRight-l breakPointM-textAlign-left textAlign-center marginBottom-l justifyContent-center marginRight-0","buttons":"src-components-modules-IndustryHeader-style----header-module---buttons---CnkfF breakPointM-flexDirection-row flexDirection-column justifyContent-start display-flex","label":"src-components-modules-IndustryHeader-style----header-module---label---715vJ","leftButton":"src-components-modules-IndustryHeader-style----header-module---leftButton---7UUP8 breakPointM-paddingRight-xxs breakPointM-paddingBottom-0 paddingBottom-xs","heading":"src-components-modules-IndustryHeader-style----header-module---heading---2IHjT fontWeight-5 marginBottom-m fontSize-xxxl breakPointS-fontSize-xxxxl","rightButton":"src-components-modules-IndustryHeader-style----header-module---rightButton---3L5Nk breakPointM-paddingLeft-xxs","secondCol":"src-components-modules-IndustryHeader-style----header-module---secondCol---2NiBb"};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Logos;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _logosModule = __webpack_require__(254);
	
	var _logosModule2 = _interopRequireDefault(_logosModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logos(_ref) {
	  var logos = _ref.logos,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm', color: 'black' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _logosModule2.default.flex },
	      _react2.default.createElement(_logoRow2.default, {
	        logos: logos,
	        align: 'center',
	        color: 'black',
	        opacity: 100,
	        spacing: 'm'
	      })
	    )
	  );
	}
	
	Logos.propTypes = {
	  title: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  logos: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.array])
	};
	module.exports = exports['default'];

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-Logos-style----logos-module---flex---1UFmy alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-components-modules-Logos-style----logos-module---cta---2mOF- paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};

/***/ }),

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _democratise2x = __webpack_require__(863);
	
	var _democratise2x2 = _interopRequireDefault(_democratise2x);
	
	var _feedback2x = __webpack_require__(2529);
	
	var _feedback2x2 = _interopRequireDefault(_feedback2x);
	
	var _hero2x = __webpack_require__(2530);
	
	var _hero2x2 = _interopRequireDefault(_hero2x);
	
	var _people2x = __webpack_require__(2531);
	
	var _people2x2 = _interopRequireDefault(_people2x);
	
	var _userTesting2x = __webpack_require__(2532);
	
	var _userTesting2x2 = _interopRequireDefault(_userTesting2x);
	
	var _designThinking2x = __webpack_require__(2528);
	
	var _designThinking2x2 = _interopRequireDefault(_designThinking2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  hero: {
	    alt: 'Deliver world class design to your clients, in record time',
	    src: _hero2x2.default,
	    maxWidth: 647
	  },
	  democratise: {
	    alt: 'Democratise design by giving every team access to the right tools',
	    src: _democratise2x2.default,
	    maxWidth: 660
	  },
	  feedback: {
	    alt: 'Bridge communication gaps with clients',
	    src: _feedback2x2.default,
	    maxWidth: 647
	  },
	  people: {
	    alt: 'Speed up time to sign off',
	    src: _people2x2.default,
	    maxWidth: 570
	  },
	  userTesting: {
	    alt: 'Test work with internal and external stakeholders',
	    src: _userTesting2x2.default,
	    maxWidth: 660
	  },
	  designThinking: {
	    src: _designThinking2x2.default,
	    maxWidth: 1200
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BlueState = __webpack_require__(1139);
	
	var _BlueState2 = _interopRequireDefault(_BlueState);
	
	var _Rapp = __webpack_require__(1151);
	
	var _Rapp2 = _interopRequireDefault(_Rapp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logos = [{
	  id: 0,
	  logo: _BlueState2.default
	}, {
	  id: 1,
	  logo: _Rapp2.default
	}];
	
	exports.default = logos;
	module.exports = exports['default'];

/***/ }),

/***/ 2528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/design-thinking@2x-a55931bc0fad1cc294bb1040c96ea642.jpg";

/***/ }),

/***/ 2529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feedback@2x-b15677306541e00a74c6b56a7d44c7d8.jpg";

/***/ }),

/***/ 2530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero@2x-67ce2c0db7d585a462582dfb8de41629.jpg";

/***/ }),

/***/ 2531:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/people@2x-d9cd5978d5b764d1120abf210590e5fc.jpg";

/***/ }),

/***/ 2532:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/user-testing@2x-02745d8a08822453f32f29348b696acb.jpg";

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/democratise@2x-fcb93c33bc9e2798b7af1400a7a95090.jpg";

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = IndustryAgencies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(1220);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _logos = __webpack_require__(1221);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _ImageBlock = __webpack_require__(149);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _CtaDemo = __webpack_require__(199);
	
	var _CtaDemo2 = _interopRequireDefault(_CtaDemo);
	
	var _Logos = __webpack_require__(206);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _IndustryHeader = __webpack_require__(204);
	
	var _IndustryHeader2 = _interopRequireDefault(_IndustryHeader);
	
	var _hubspot = __webpack_require__(46);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookMeta = [{
	  name: 'og:title',
	  content: 'Marvel for Agencies | Wireframe, Prototype, Design & Test'
	}, {
	  name: 'og:site_name',
	  content: 'Marvel for Agencies'
	}, {
	  name: 'og:type',
	  content: 'website'
	}, {
	  name: 'og:url',
	  content: 'https://marvelapp.com/prototyping-for-design-agencies'
	}, {
	  name: 'og:description',
	  content: 'Design and Prototyping for Design Agencies. Explore how Marvel can help you deliver beautiful design work to clients in one collaborative platform.'
	}, {
	  name: 'og:image',
	  content: 'https://marvelapp.com' + _assets2.default.designThinking.src
	}, {
	  name: 'og:site_name',
	  content: 'Marvel for Agencies'
	}];
	
	var twitterMeta = [{
	  name: 'twitter:site',
	  content: 'https://marvelapp.com/prototyping-for-design-agencies'
	}, {
	  name: 'twitter:creator',
	  content: '@marvelapp'
	}, {
	  name: 'twitter:title',
	  content: 'Marvel for Agencies | Wireframe, Prototype, Design & Test'
	}, {
	  name: 'twitter:image',
	  content: 'https://marvelapp.com' + _assets2.default.designThinking.src
	}];
	
	var meta = {
	  title: _metadata2.default['prototyping-for-design-agencies'].title,
	  meta: [{
	    name: 'description',
	    content: _metadata2.default['prototyping-for-design-agencies'].description
	  }].concat(twitterMeta, facebookMeta),
	  header: { isLight: false },
	  footer: false
	};
	
	function IndustryAgencies() {
	  var ctaLink = '/enterprise/request-demo?hformid=' + _hubspot.requestDemoAgencyId;
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(_IndustryHeader2.default, {
	      label: 'Marvel for Agencies',
	      imageAsset: _assets2.default.hero,
	      title: 'Deliver world class design to your clients, in record time ',
	      paragraph: _react2.default.createElement(
	        'span',
	        null,
	        'In design, good client relationships can steer and streamline success. However, delivering the best client experience from brief to sign off can be tricky, whether that\u2019s due to lack of collaborative tools, design understanding or tight deadlines. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'With Marvel, design teams can present low fidelity and hi fidelity prototypes to clients either on the big screen or quickly shared via URL to any device. The platform\u2019s seamless collaboration tools drive powerful client communication that helps you achieve more, faster.'
	      ),
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_Logos2.default, {
	      title: _react2.default.createElement(
	        'span',
	        null,
	        'Join these leading Agencies companies who use',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { style: { fontWeight: 'bold' } },
	          'Marvel Enterprise'
	        ),
	        ' to scale design'
	      ),
	      logos: _logos2.default
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Democratise design by giving every team access to the right tools',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'From designers to researchers and analysts, Marvel consolidates and simplifies dozens of professional, creative workflow tools - enabling every department to wireframe, design and prototype. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'We strive to lower the entry barrier for design and creative tooling. That\'s why it takes less than 30 minutes to onboard and complete your first project with Marvel. With no learning curve, our platform empowers every team to drive a design-led culture.'
	      ),
	      headingMaxWidth: 390,
	      paragraphMaxWidth: 480,
	      imageAsset: _assets2.default.democratise,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Bridge communication gaps with clients',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Client work should be an ongoing collaborative process, but often feedback can get lost in email chains or left undeciphered in meeting notes. Marvel\u2019s commenting features mean both your team and your external stakeholders can leave annotated notes across designs - so feedback is clear, documented and all in one place. Our dedicated \u2018External Reviewer\u2019 role sets restrictions on access, without exclusion.'
	      ),
	      headingMaxWidth: 390,
	      paragraphMaxWidth: 480,
	      imageAsset: _assets2.default.feedback,
	      isRightAligned: true,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Speed up time to sign off',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'We know it can be difficult to get the right people in the same room at the same time. With Marvel, you can share prototypes and design work with a simple and secure URL. Clients and teams can quickly leave feedback through comments and annotations directly on designs to move projects to sign off faster.'
	      ),
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.people,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Test work with internal and external stakeholders',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Every product or feature is designed with a goal in mind that you want the end-user to achieve. Marvel helps you hit that goal through our User Testing tools where you can improve the experience for your clients end-users or customers. Gather audio, visual and analytical data on prototypes to guide your iterations and create a fantastic user experience.'
	      ),
	      headingMaxWidth: 458,
	      paragraphMaxWidth: 458,
	      imageAsset: _assets2.default.userTesting,
	      isRightAligned: true,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Drive co-creation with ease',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Better products are made together but with most tools having a steep learning curve, it can be difficult for stakeholders to adopt or get involved. Marvel isn\u2019t just for designers. The simplicity of our design platform means it\u2019s easy for anyone to onboard, access prototypes and create them too. Marvel supports users through the Design Thinking process which helps ideate and create user-centric products.',
	        ' ',
	        _react2.default.createElement(
	          _link2.default,
	          { type: 'blue', url: 'https://marvelapp.com/workshops' },
	          'Download the free kit.'
	        )
	      ),
	      headingMaxWidth: 458,
	      paragraphMaxWidth: 458,
	      imageAsset: _assets2.default.designThinking,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'bg-snow' },
	      _react2.default.createElement(_CtaDemo2.default, {
	        heading: 'Challenge the industry norm and become a CX centric design leader with Marvel Enterprise.',
	        ctaLink: ctaLink
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-prototyping-for-design-agencies-index-js-bc8f8c0b662511d4274a.js